import { format, parseISO } from 'date-fns'

/**
 * DateオブジェクトまたはDate文字列を安全にISO 8601形式（YYYY-MM-DD）に変換するためのヘルパー関数
 * @param dateValue 変換するDate文字列またはDateオブジェクト (null, undefined, 空文字を含む)
 * @returns ISO形式の日付文字列、または無効な場合は空文字
 */
export const safeFormatISO = (
  dateValue: string | Date | null | undefined
): string => {
  // Dateオブジェクトの場合はformatを使用
  if (dateValue instanceof Date) {
    return isNaN(dateValue.getTime()) ? '' : format(dateValue, 'yyyy-MM-dd')
  }

  // 文字列の場合はparseISOしてからformatを使用
  if (typeof dateValue === 'string' && dateValue.length > 0) {
    try {
      const parsedDate = parseISO(dateValue)
      // パースされた日付が有効かチェック
      if (!isNaN(parsedDate.getTime())) {
        return format(parsedDate, 'yyyy-MM-dd')
      } else {
        return ''
      }
    } catch (e) {
      return ''
    }
  }
  return ''
}
